import React, { useContext, useMemo } from "react";
import { useParams } from "react-router-dom";
import Layout from "../Layout/Layout";
import { AgencyContext } from "./AgencyProvider/AgencyProvider";
import { SettingContext } from "./Reducer/SettingProvider";
import Agent from "./Agent/Agent";
import ApiKey from "./APIKey/ApiKey";
import Billing from "./Billing/Billing";
import ManageTeams from "./Manage-Teams/ManageTeams";
import Profile from "./Profile/Profile";
import Usage from "./Usage/Usage";
import Webhooks from "./Webhooks";
import YourKeys from "./YourKeys/YourKeys";

const SettingsWrapper = () => {
  const { name = "profile" } = useParams();
  const { state } = useContext(SettingContext);
  const hasHumanAgents = state?.credits?.human_agents > 0;
  const agency = useContext(AgencyContext);
  const tabs = useMemo(() => {
    const defaultTabs = [
      { name: "Profile", route: "/settings/profile", component: Profile },
      // { name: "Channels", route: "/settings/channels", component: Channels },
      { name: "Webhooks", route: "/settings/webhooks", component: Webhooks },
      { name: "Usage", route: "/settings/usage", component: Usage },
      {
        name: agency?.myDetails?.agency_id ? "Billing" : "Billing & Wallet",
        route: "/settings/billing",
        component: Billing,
      },
      { name: "API Keys", route: "/settings/api-keys", component: ApiKey },
      {
        name: "Your Provider Keys",
        route: "/settings/your-keys",
        component: YourKeys,
      },
    ];

    defaultTabs.push({ name: "Teams", route: "/settings/teams", component: ManageTeams });
    if (hasHumanAgents) {
      defaultTabs.push({
        name: "Human Agents",
        route: "/settings/agents",
        component: Agent,
      });
    }
    return defaultTabs;
  }, [hasHumanAgents]);

  // Fall back to Profile when the URL points at a tab that isn't in
  // the current list — e.g. a stale bookmark, a deprecated path, or a
  // conditional tab like "Human Agents" that was removed while the
  // user was viewing it. Without this guard `tabs[-1].component`
  // crashed the entire route.
  const defaultTab = tabs.findIndex((tab) => tab.route === `/settings/${name}`);
  const activeTab = defaultTab >= 0 ? tabs[defaultTab] : tabs[0];
  const RenderComponent = activeTab.component;

  return <RenderComponent />;
};

export default SettingsWrapper;
